/* keyframes-motion.tsx generated by @compiled/babel-plugin v3.0.2 */
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3Y6bKp38c8%7Banimation-fill-mode%3Abackwards%7D%0A._4Cu53BeMto%7Banimation-play-state%3Arunning%7D%0A%40media%20(prefers-reduced-motion%3Areduce)%7B._39Ohv4YbGa%7Banimation%3Anone%7D._1SdfoHYbGa%7Btransition%3Anone%7D%7D%0A._4Cu53BP4vI%7Banimation-play-state%3Apaused%7D%0A._0nFVCGe6K4%7Banimation-duration%3A.1s%7D%0A._0nFVCGngV3%7Banimation-duration%3A.35s%7D%0A._0nFVCG0G4o%7Banimation-duration%3A.7s%7D%0A._0nFVCGjH1t%7Banimation-duration%3A50ms%7D%0A._0nFVCGnQ85%7Banimation-duration%3A175ms%7D%0A._1jakNnUaiG%7Banimation-delay%3A0ms%7D%0A._3Y6bKpgRhm%7Banimation-fill-mode%3Aforwards%7D%0A._43vdfTHVQb%7Banimation-timing-function%3Alinear%7D%0A._43vdfTzx0n%7Banimation-timing-function%3Acubic-bezier(.2%2C0%2C0%2C1)%7D%0A._43vdfTsRAN%7Banimation-timing-function%3Acubic-bezier(.8%2C0%2C0%2C.8)%7D%0A._43vdfTlmpr%7Banimation-timing-function%3Acubic-bezier(.4%2C0%2C0%2C1)%7D%0A._43vdfT6a7c%7Banimation-timing-function%3Acubic-bezier(.6%2C0%2C0%2C1)%7D%0A._43vdfTBOqL%7Banimation-timing-function%3Acubic-bezier(.8%2C0%2C0%2C1)%7D%0A._43vdfT8f3n%7Banimation-timing-function%3Acubic-bezier(.15%2C1%2C.3%2C1)%7D%0A%40keyframes%20kij747q%7B0%25%7Bopacity%3A0%7D50%25%7Bopacity%3A1%7Dto%7Bopacity%3A1%7D%7D%0A._1gBibykeLs%7Banimation-name%3Akij747q%7D%0A%40keyframes%20kbjizr2%7B0%25%7Bopacity%3A1%7Dto%7Bopacity%3A0%7D%7D%0A._1gBibyI0gR%7Banimation-name%3Akbjizr2%7D%0A%40keyframes%20k1rq2oqw%7B0%25%7Bopacity%3A0%3Btransform%3Ascale(.5)%7D50%25%7Bopacity%3A1%7D75%25%7Btransform%3Ascale(1.25)%7Dto%7Btransform%3Ascale(1)%7D%7D%0A._1gBibyhdkL%7Banimation-name%3Ak1rq2oqw%7D%0A%40keyframes%20k1tay9q1%7Bto%7Bopacity%3A0%3Btransform%3Ascale(.75)%7D%7D%0A._1gBibyTD4f%7Banimation-name%3Ak1tay9q1%7D%0A%40keyframes%20k1j8u6o8%7B0%25%7Btransform%3Atranslate3d(0%2C-100%25%2C0)%3Bopacity%3A0%7Dto%7Btransform%3Anone%3Bopacity%3A1%7D%7D%0A._1gBibyDhyF%7Banimation-name%3Ak1j8u6o8%7D%0A%40keyframes%20k1ydy56c%7B0%25%7Btransform%3Anone%3Bopacity%3A1%7Dto%7Btransform%3Atranslate3d(0%2C-100%25%2C0)%3Bopacity%3A0%7D%7D%0A._1gBibyLNze%7Banimation-name%3Ak1ydy56c%7D%0A%40keyframes%20k8nf8el%7B0%25%7Btransform%3Atranslate3d(100%25%2C0%2C0)%3Bopacity%3A0%7Dto%7Btransform%3Anone%3Bopacity%3A1%7D%7D%0A._1gBibyXOlu%7Banimation-name%3Ak8nf8el%7D%0A%40keyframes%20k1bbsfcj%7B0%25%7Btransform%3Anone%3Bopacity%3A1%7Dto%7Btransform%3Atranslate3d(100%25%2C0%2C0)%3Bopacity%3A0%7D%7D%0A._1gBibySaA1%7Banimation-name%3Ak1bbsfcj%7D%0A%40keyframes%20kqit24e%7B0%25%7Btransform%3Atranslate3d(0%2C100%25%2C0)%3Bopacity%3A0%7Dto%7Btransform%3Anone%3Bopacity%3A1%7D%7D%0A._1gBibynyVM%7Banimation-name%3Akqit24e%7D%0A%40keyframes%20k1vmhg30%7B0%25%7Btransform%3Anone%3Bopacity%3A1%7Dto%7Btransform%3Atranslate3d(0%2C100%25%2C0)%3Bopacity%3A0%7D%7D%0A._1gBibye6Fr%7Banimation-name%3Ak1vmhg30%7D%0A%40keyframes%20k1na2ju7%7B0%25%7Btransform%3Atranslate3d(-100%25%2C0%2C0)%3Bopacity%3A0%7Dto%7Btransform%3Anone%3Bopacity%3A1%7D%7D%0A._1gBibyoziG%7Banimation-name%3Ak1na2ju7%7D%0A%40keyframes%20k1wh49cw%7B0%25%7Btransform%3Anone%3Bopacity%3A1%7Dto%7Btransform%3Atranslate3d(-100%25%2C0%2C0)%3Bopacity%3A0%7D%7D%0A._1gBibyMeos%7Banimation-name%3Ak1wh49cw%7D%0A%40keyframes%20kecjqy3%7B0%25%7Bopacity%3A0%3Btransform%3Atranslate3d(0%2Ccalc(-5%25%20-%204px)%2C0)%7D50%25%7Bopacity%3A1%7Dto%7Bopacity%3A1%3Btransform%3Anone%7D%7D%0A._1gBibykcI4%7Banimation-name%3Akecjqy3%7D%0A%40keyframes%20k1sspn6e%7B0%25%7Bopacity%3A1%3Btransform%3Atranslate3d(0%2C0%2C0)%7Dto%7Bopacity%3A0%3Btransform%3Atranslate3d(0%2Ccalc(-5%25%20-%204px)%2C0)%7D%7D%0A._1gBibyoGbB%7Banimation-name%3Ak1sspn6e%7D%0A%40keyframes%20k1y4xa46%7B0%25%7Bopacity%3A0%3Btransform%3Atranslate3d(calc(-5%25%20-%204px)%2C0%2C0)%7D50%25%7Bopacity%3A1%7Dto%7Bopacity%3A1%3Btransform%3Anone%7D%7D%0A._1gBibyhAdH%7Banimation-name%3Ak1y4xa46%7D%0A%40keyframes%20k12cqms0%7B0%25%7Bopacity%3A1%3Btransform%3Atranslate3d(0%2C0%2C0)%7Dto%7Bopacity%3A0%3Btransform%3Atranslate3d(calc(-5%25%20-%204px)%2C0%2C0)%7D%7D%0A._1gBibyAEay%7Banimation-name%3Ak12cqms0%7D%0A%40keyframes%20k9i97cc%7B0%25%7Bopacity%3A0%3Btransform%3Atranslate3d(0%2Ccalc(5%25%20%2B%204px)%2C0)%7D50%25%7Bopacity%3A1%7Dto%7Bopacity%3A1%3Btransform%3Anone%7D%7D%0A._1gBibygoNB%7Banimation-name%3Ak9i97cc%7D%0A%40keyframes%20kwlxyjp%7B0%25%7Bopacity%3A1%3Btransform%3Atranslate3d(0%2C0%2C0)%7Dto%7Bopacity%3A0%3Btransform%3Atranslate3d(0%2Ccalc(5%25%20%2B%204px)%2C0)%7D%7D%0A._1gBiby6f4m%7Banimation-name%3Akwlxyjp%7D%0A%40keyframes%20k1gp9ioh%7B0%25%7Bopacity%3A0%3Btransform%3Atranslate3d(calc(5%25%20%2B%204px)%2C0%2C0)%7D50%25%7Bopacity%3A1%7Dto%7Bopacity%3A1%3Btransform%3Anone%7D%7D%0A._1gBibyi3nN%7Banimation-name%3Ak1gp9ioh%7D%0A%40keyframes%20k1dj5hf1%7B0%25%7Bopacity%3A1%3Btransform%3Atranslate3d(0%2C0%2C0)%7Dto%7Bopacity%3A0%3Btransform%3Atranslate3d(calc(5%25%20%2B%204px)%2C0%2C0)%7D%7D%0A._1gBibyUa70%7Banimation-name%3Ak1dj5hf1%7D%0A%40keyframes%20k1fo8igf%7B0%25%7Bopacity%3A0%3Btransform%3Atranslate3d(0%2C-4px%2C0)%7D50%25%7Bopacity%3A1%7Dto%7Bopacity%3A1%3Btransform%3Anone%7D%7D%0A._1gBibyisTU%7Banimation-name%3Ak1fo8igf%7D%0A%40keyframes%20k11647nu%7B0%25%7Bopacity%3A1%3Btransform%3Atranslate3d(0%2C0%2C0)%7Dto%7Bopacity%3A0%3Btransform%3Atranslate3d(0%2C-4px%2C0)%7D%7D%0A._1gBibyGz7o%7Banimation-name%3Ak11647nu%7D%0A%40keyframes%20km3530i%7B0%25%7Bopacity%3A0%3Btransform%3Atranslate3d(-4px%2C0%2C0)%7D50%25%7Bopacity%3A1%7Dto%7Bopacity%3A1%3Btransform%3Anone%7D%7D%0A._1gBibyMMUA%7Banimation-name%3Akm3530i%7D%0A%40keyframes%20k7ccisj%7B0%25%7Bopacity%3A1%3Btransform%3Atranslate3d%7Dto%7Bopacity%3A0%3Btransform%3Atranslate3d(-4px%2C0%2C0)%7D%7D%0A._1gBibykux3%7Banimation-name%3Ak7ccisj%7D%0A%40keyframes%20k1h8oue3%7B0%25%7Bopacity%3A0%3Btransform%3Atranslate3d(0%2C4px%2C0)%7D50%25%7Bopacity%3A1%7Dto%7Bopacity%3A1%3Btransform%3Anone%7D%7D%0A._1gBibyGPd4%7Banimation-name%3Ak1h8oue3%7D%0A%40keyframes%20k73gfcn%7B0%25%7Bopacity%3A1%3Btransform%3Atranslate3d(0%2C0%2C0)%7Dto%7Bopacity%3A0%3Btransform%3Atranslate3d(0%2C4px%2C0)%7D%7D%0A._1gBibyHnxz%7Banimation-name%3Ak73gfcn%7D%0A%40keyframes%20k1vint76%7B0%25%7Bopacity%3A0%3Btransform%3Atranslate3d(4px%2C0%2C0)%7D50%25%7Bopacity%3A1%7Dto%7Bopacity%3A1%3Btransform%3Anone%7D%7D%0A._1gBibyFRSA%7Banimation-name%3Ak1vint76%7D%0A%40keyframes%20k1ylodgn%7B0%25%7Bopacity%3A1%3Btransform%3Atranslate3d(0%2C0%2C0)%7Dto%7Bopacity%3A0%3Btransform%3Atranslate3d(4px%2C0%2C0)%7D%7D%0A._1gBibyw0wK%7Banimation-name%3Ak1ylodgn%7D");









































































import React, { type Ref, useEffect, useState } from 'react';
import { ax, ix } from '@compiled/react/runtime';
import { type Durations, durations } from '../utils/durations';
import { exitingDurations } from '../utils/exiting-durations';
import { isReducedMotion } from '../utils/is-reduced-motion';
import { useSetTimeout } from '../utils/use-set-timeout';
import { type AnimationCurve, type Direction, type MotionProps } from './types';
import { useExitingPersistence } from './use-exiting-persistence';
import { useStaggeredEntrance } from './use-staggered-entrance';
const zoomIn = null;
const zoomOut = null;
const fadeIn = null;
const fadeOut = null;
const fadeInFromTop = null;
const fadeOutFromTop = null;
const fadeInFromLeft = null;
const fadeOutFromLeft = null;
const fadeInFromBottom = null;
const fadeOutFromBottom = null;
const fadeInFromRight = null;
const fadeOutFromRight = null;
const fadeInFromTopConstant = null;
const fadeOutFromTopConstant = null;
const fadeInFromLeftConstant = null;
const fadeOutFromLeftConstant = null;
const fadeInFromBottomConstant = null;
const fadeOutFromBottomConstant = null;
const fadeInFromRightConstant = null;
const fadeOutFromRightConstant = null;
const slideInFromTop = null;
const slideOutFromTop = null;
const slideInFromRight = null;
const slideOutFromRight = null;
const slideInFromBottom = null;
const slideOutFromBottom = null;
const slideInFromLeft = null;
const slideOutFromLeft = null;
export type Animations = 'fade-in' | 'fade-out' | 'zoom-in' | 'zoom-out' | `slide-${'in' | 'out'}-from-${Direction}` | `slide-${'in' | 'out'}-from-${Direction}` | `fade-${'in' | 'out'}-from-${Direction}` | `fade-${'in' | 'out'}-from-${Direction}-constant`;

/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */
export interface KeyframesMotionProps extends MotionProps<{
  className: string;
  style: Record<string, any>;
  ref: Ref<any>;
}> {
  /**
   * Can be used to pause the animation before it has finished.
   */
  isPaused?: boolean;
}
interface InternalKeyframesMotionProps extends KeyframesMotionProps {
  /**
   * Timing function to be used with the animation.
   * Useful if you want a different curve when entering vs. exiting.
   */
  animationTimingFunction: AnimationCurve;

  /**
   * Timing function to be used with the animation when exiting.
   * If not provided, it will default to the entering animation timing function.
   */
  animationTimingFunctionExiting?: AnimationCurve;

  /**
   * CSS keyframes for the entering animation.
   */
  enteringAnimation: Animations;

  /**
   * CSS keyframes for the exiting animation.
   */
  exitingAnimation?: Animations;

  /**.
   * How long the motion will take.
   */
  duration: Durations;
}

/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */
const EnteringMotion = ({
  children,
  animationTimingFunction,
  animationTimingFunctionExiting = animationTimingFunction,
  enteringAnimation,
  exitingAnimation = enteringAnimation,
  isPaused,
  onFinish: onFinishMotion,
  duration = 'large'
}: InternalKeyframesMotionProps): React.JSX.Element => {
  const staggered = useStaggeredEntrance();
  const {
    isExiting,
    onFinish: onExitFinished,
    appear
  } = useExitingPersistence();
  const setTimeout = useSetTimeout();
  const paused = isPaused || !staggered.isReady;
  const delay = isExiting ? 0 : staggered.delay;
  const state = isExiting ? 'exiting' : 'entering';
  const [hasAnimationStyles, setHasAnimationStyles] = useState(appear);
  useEffect(() => {
    // Tracking this to prevent changing state on an unmounted component
    let isCancelled = false;
    if (paused) {
      return;
    }

    // On initial mount if elements aren't set to animate on appear, we return early and callback
    if (!appear) {
      onFinishMotion && onFinishMotion(state);
      return;
    }

    /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */
    const onAnimationEnd = () => {
      if (state === 'exiting') {
        // Updates the `ExitingPersistence` to remove this child
        onExitFinished?.();
      }
      if (!isCancelled) {
        setHasAnimationStyles(false);
      }
      onFinishMotion?.(state);
    };
    if (isReducedMotion()) {
      // If there is reduced motion there is no exit animation, so call this immediately
      onAnimationEnd();
      return;
    }

    // Elements may need animation styles back after initial mount (they could animate out)
    setHasAnimationStyles(true);

    // Queue `onAnimationEnd` for after the animation has finished
    setTimeout(onAnimationEnd, isExiting ? exitingDurations[duration] : durations[duration] + delay);
    return () => {
      isCancelled = true;
    };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onExitFinished, state, isExiting, duration, delay, paused, setTimeout]);
  return children({
    ref: staggered.ref,
    // @ts-expect-error: `ax` is not typed correctly
    className: hasAnimationStyles ? ax([ax(["_3Y6bKp38c8 _4Cu53BeMto _39Ohv4YbGa _1SdfoHYbGa"]), paused && ax(["_4Cu53BP4vI"]), duration === 'small' && ax(["_0nFVCGe6K4"]), duration === 'medium' && ax(["_0nFVCGngV3"]), duration === 'large' && ax(["_0nFVCG0G4o"]), isExiting && duration === 'small' && ax(["_0nFVCGjH1t"]), isExiting && duration === 'medium' && ax(["_0nFVCGnQ85"]), isExiting && duration === 'large' && ax(["_0nFVCGngV3"]), isExiting && ax(["_1jakNnUaiG _3Y6bKpgRhm"]), !isExiting && animationTimingFunction === 'linear' && ax(["_43vdfTHVQb"]), !isExiting && animationTimingFunction === 'ease-out' && ax(["_43vdfTzx0n"]), !isExiting && animationTimingFunction === 'ease-in' && ax(["_43vdfTsRAN"]), !isExiting && animationTimingFunction === 'ease-in-40-out' && ax(["_43vdfTlmpr"]), !isExiting && animationTimingFunction === 'ease-in-60-out' && ax(["_43vdfT6a7c"]), !isExiting && animationTimingFunction === 'ease-in-80-out' && ax(["_43vdfTBOqL"]), !isExiting && animationTimingFunction === 'ease-in-out' && ax(["_43vdfT8f3n"]), isExiting && animationTimingFunction === 'linear' && ax(["_43vdfTHVQb"]), isExiting && animationTimingFunctionExiting === 'ease-out' && ax(["_43vdfTzx0n"]), isExiting && animationTimingFunctionExiting === 'ease-in' && ax(["_43vdfTsRAN"]), isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && ax(["_43vdfTlmpr"]), isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && ax(["_43vdfT6a7c"]), isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && ax(["_43vdfTBOqL"]), isExiting && animationTimingFunctionExiting === 'ease-in-out' && ax(["_43vdfT8f3n"]), (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && ax(["_1gBibykeLs"]), (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && ax(["_1gBibyI0gR"]), (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && ax(["_1gBibyhdkL"]), (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && ax(["_1gBibyTD4f"]), (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && ax(["_1gBibyDhyF"]), (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && ax(["_1gBibyLNze"]), (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && ax(["_1gBibyXOlu"]), (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && ax(["_1gBibySaA1"]), (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && ax(["_1gBibynyVM"]), (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && ax(["_1gBibye6Fr"]), (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && ax(["_1gBibyoziG"]), (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && ax(["_1gBibyMeos"]), (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && ax(["_1gBibykcI4"]), (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && ax(["_1gBibyoGbB"]), (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && ax(["_1gBibyhAdH"]), (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && ax(["_1gBibyAEay"]), (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && ax(["_1gBibygoNB"]), (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && ax(["_1gBiby6f4m"]), (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && ax(["_1gBibyi3nN"]), (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && ax(["_1gBibyUa70"]), (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && ax(["_1gBibyisTU"]), (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && ax(["_1gBibyGz7o"]), (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && ax(["_1gBibyMMUA"]), (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && ax(["_1gBibykux3"]), (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && ax(["_1gBibyGPd4"]), (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && ax(["_1gBibyHnxz"]), (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && ax(["_1gBibyFRSA"]), (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && ax(["_1gBibyw0wK"])]) : '',
    style: {
      animationDelay: `${delay}ms`
    }
  }, state);
};
export default EnteringMotion;